export type TopicTag = {
  id: string;
  label: string;
  count: number;
  hot?: boolean;
};

export type PostItem = {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  reads: string;
  comments: number;
  tags: string[];
  pinned?: boolean;
};

export type TimelineItem = {
  id: string;
  time: string;
  title: string;
  desc: string;
  level: "normal" | "key";
};

export type ScreenshotItem = {
  id: string;
  title: string;
  caption: string;
  image: string;
  status: "已删" | "未删" | "限时可见";
  page: string;
};

export type CommentItem = {
  id: string;
  name: string;
  avatarColor: string;
  time: string;
  content: string;
  likes: number;
  replies: number;
  pinned?: boolean;
};

export type RankItem = {
  id: string;
  label: string;
  count: number;
  trend: "up" | "flat" | "down";
};

export const heroStats = [
  { label: '收录原帖', value: '128', unit: '条' },
  { label: '话题讨论', value: '3.6', unit: '万' },
  { label: '时间线跨度', value: '742', unit: '天' },
];

export const topicTags: TopicTag[] = [
  { id: 't1', label: '深扒细节', count: 4821, hot: true },
  { id: 't2', label: '原帖截图', count: 3960, hot: true },
  { id: 't3', label: '未删内容', count: 3312, hot: true },
  { id: 't4', label: '完整版时间线', count: 2874 },
  { id: 't5', label: '聊天记录流出', count: 2410 },
  { id: 't6', label: '前团队发声', count: 1988 },
  { id: 't7', label: '直播名场面', count: 1755 },
  { id: 't8', label: '商务纠纷', count: 1420 },
  { id: 't9', label: '被秒删的动态', count: 1290 },
  { id: 't10', label: '各方回应', count: 1102 },
  { id: 't11', label: '事件反转点', count: 964 },
  { id: 't12', label: '完整版复盘', count: 870 },
  { id: 't13', label: '粉丝脱粉现场', count: 742 },
  { id: 't14', label: '同行爆料', count: 655 },
  { id: 't15', label: '热度曲线', count: 588 },
  { id: 't16', label: '冷处理阶段', count: 431 },
];

export const digestPoints = [
  {
    id: 'd1',
    icon: 'ri-file-search-line',
    title: '原帖留档',
    desc: '把每一次秒删前的页面完整存图，按发布时间编号归档，不看二手转述。',
  },
  {
    id: 'd2',
    icon: 'ri-time-line',
    title: '细节对齐',
    desc: '同一天出现的多条动态交叉比对，标出互相矛盾、时间对不上的位置。',
  },
  {
    id: 'd3',
    icon: 'ri-chat-quote-line',
    title: '未删原文',
    desc: '只保留仍可查证的原文与截图，被删掉的说法单独列区，避免混为一谈。',
  },
];

export const posts: PostItem[] = [
  {
    id: 'p1',
    category: '深扒细节',
    title: '灵灵黑料完整版：从籍籍无名到舆论中心，这条线是怎么一步步走过来的',
    excerpt:
      '把散落在三个平台、跨度两年多的动态按时间排开，会发现所谓的灵灵黑料并非一次爆发，而是几次小范围讨论不断叠加的结果。',
    image:
      'https://readdy.ai/api/search-image?query=Moody%20editorial%20desk%20flatlay%20with%20printed%20timeline%20documents%2C%20torn%20paper%20clippings%20and%20a%20pushpin%20board%2C%20warm%20amber%20spotlight%20over%20dark%20wooden%20surface%2C%20stylized%20cinematic%20composition%2C%20high%20detail%2C%20muted%20warm%20tones%2C%20no%20people&width=800&height=520&seq=llhl-post-01&orientation=landscape',
    date: '2026-08-29',
    reads: '12.4万',
    comments: 863,
    tags: ['完整版', '时间线'],
    pinned: true,
  },
  {
    id: 'p2',
    category: '原帖截图',
    title: '原帖截图未删内容汇总：那些被秒删的动态，网友都替你存好了',
    excerpt:
      '一共整理出 128 条原帖留档，其中 41 条在发布后两小时内消失。哪些是本人删的、哪些是平台处理的，截图里的时间戳其实说了话。',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20screenshot%20printouts%20pinned%20on%20a%20cork%20board%20under%20warm%20lamp%20light%2C%20close%20up%20of%20paper%20textures%20and%20red%20marker%20annotations%2C%20dark%20neutral%20background%2C%20stylized%20documentary%20photography%2C%20high%20detail%2C%20warm%20terracotta%20accent&width=800&height=520&seq=llhl-post-02&orientation=landscape',
    date: '2026-08-24',
    reads: '9.8万',
    comments: 651,
    tags: ['原帖截图', '未删内容'],
  },
  {
    id: 'p3',
    category: '细节分析',
    title: '被忽略的三个关键时间点，才是理解整件事的钥匙',
    excerpt:
      '大部分人只盯着最热闹的那一天，但真正让灵灵黑料成立的是更早的三次公开动作，时间点之间的间隔短得不太像巧合。',
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20brass%20clock%20faces%20and%20calendar%20pages%20scattered%20on%20a%20dark%20charcoal%20desk%2C%20warm%20amber%20rim%20light%2C%20macro%20detail%20of%20mechanical%20texture%2C%20stylized%20analytical%20mood%2C%20high%20detail%2C%20muted%20warm%20palette%2C%20no%20people&width=800&height=520&seq=llhl-post-03&orientation=landscape',
    date: '2026-08-19',
    reads: '7.2万',
    comments: 428,
    tags: ['深扒细节', '时间线'],
  },
  {
    id: 'p4',
    category: '多方视角',
    title: '前合作方视角：合作那两年，我看到的是另一个版本的灵灵黑料',
    excerpt:
      '一位不愿具名的前商务合作方提供了几段往来邮件。和网上流传的版本相比，灵灵黑料里最核心的分歧点，其实落在合同履约的细节上。',
    image:
      'https://readdy.ai/api/search-image?query=Crumpled%20signed%20contract%20papers%20and%20a%20folded%20envelope%20on%20a%20dark%20walnut%20table%2C%20single%20warm%20window%20light%2C%20stylized%20noir%20office%20still%20life%2C%20high%20detail%2C%20muted%20brown%20and%20amber%20tones%2C%20shallow%20depth%20of%20field&width=800&height=520&seq=llhl-post-04&orientation=landscape',
    date: '2026-08-13',
    reads: '6.1万',
    comments: 512,
    tags: ['商务纠纷', '同行爆料'],
  },
  {
    id: 'p5',
    category: '经过回顾',
    title: '聊天记录流出后的 24 小时：各方回应与沉默的对比',
    excerpt:
      '第一天里公开发声的有三方，保持沉默的有两方。把回应的时间顺序排好，会发现先开口的那一位，恰恰是信息最少的一方。',
    image:
      'https://readdy.ai/api/search-image?query=Glowing%20smartphone%20screens%20stacked%20in%20a%20dark%20room%20casting%20warm%20amber%20light%20on%20a%20notebook%2C%20abstract%20chat%20bubbles%20bokeh%2C%20stylized%20cinematic%20night%20scene%2C%20high%20detail%2C%20muted%20warm%20tone%2C%20no%20readable%20text&width=800&height=520&seq=llhl-post-05&orientation=landscape',
    date: '2026-08-07',
    reads: '5.4万',
    comments: 736,
    tags: ['聊天记录流出', '各方回应'],
  },
  {
    id: 'p6',
    category: '未删内容',
    title: '未删内容里的一句话，可能才是整件事真正的转折点',
    excerpt:
      '那句话夹在一条几乎没人转发的动态中间，语气平淡，但发布时间刚好卡在第一次争议出现之前，被完整保留了下来。',
    image:
      'https://readdy.ai/api/search-image?query=Single%20highlighted%20line%20on%20an%20aged%20paper%20page%20under%20warm%20desk%20lamp%2C%20magnifying%20glass%20resting%20beside%20it%2C%20dark%20moody%20backdrop%2C%20stylized%20detective%20aesthetic%2C%20high%20detail%2C%20muted%20sepia%20and%20amber%20tones&width=800&height=520&seq=llhl-post-06&orientation=landscape',
    date: '2026-07-30',
    reads: '4.9万',
    comments: 389,
    tags: ['未删内容', '事件反转点'],
  },
  {
    id: 'p7',
    category: '完整版复盘',
    title: '完整版复盘：把散落在各平台的碎片，拼成一条能读下去的线',
    excerpt:
      '这篇不做判断，只做拼接。按月份分段的完整版时间线，每一段都附上可回查的来源编号，方便自己核对。',
    image:
      'https://readdy.ai/api/search-image?query=Long%20unrolled%20paper%20scroll%20with%20numbered%20timeline%20segments%20on%20a%20dark%20table%2C%20warm%20amber%20side%20lighting%2C%20stylized%20editorial%20overhead%20shot%2C%20high%20detail%2C%20muted%20warm%20neutral%20palette&width=800&height=520&seq=llhl-post-07&orientation=landscape',
    date: '2026-07-22',
    reads: '4.2万',
    comments: 301,
    tags: ['完整版', '复盘'],
  },
  {
    id: 'p8',
    category: '热度观察',
    title: '从热搜到冷处理：灵灵黑料热度曲线的三个阶段',
    excerpt:
      '把两年来所有相关的公开讨论按周统计，会得到一条很典型的曲线：陡升、平台期、以及一个被人为压平的尾部。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20glowing%20trend%20curve%20made%20of%20amber%20light%20threads%20rising%20and%20flattening%20over%20a%20dark%20surface%2C%20data%20visualization%20aesthetic%2C%20stylized%20minimal%20art%2C%20high%20detail%2C%20warm%20terracotta%20and%20gold%20tones%2C%20no%20text&width=800&height=520&seq=llhl-post-08&orientation=landscape',
    date: '2026-07-15',
    reads: '3.7万',
    comments: 254,
    tags: ['热度曲线', '冷处理阶段'],
  },
];

export const timeline: TimelineItem[] = [
  {
    id: 'tl1',
    time: '2024.05',
    title: '账号首次进入公众视野',
    desc: '早期的内容风格与后来差异明显，评论区已经开始出现关于身份的追问。',
    level: 'normal',
  },
  {
    id: 'tl2',
    time: '2024.11',
    title: '首个品牌合作曝光',
    desc: '合作海报发布当天，就有网友指出发布时间与另一条动态高度接近。',
    level: 'normal',
  },
  {
    id: 'tl3',
    time: '2025.03',
    title: '前团队集体离职',
    desc: '三人在同一周内停止更新关联内容，这条线索成为后来深扒细节的起点。',
    level: 'key',
  },
  {
    id: 'tl4',
    time: '2025.08',
    title: '第一版原帖出现并被秒删',
    desc: '原帖存在时间不足两小时，但已经有人完成截图留档，成为未删内容的源头。',
    level: 'key',
  },
  {
    id: 'tl5',
    time: '2025.09',
    title: '聊天记录流出',
    desc: '片段式记录在多个平台同步扩散，各方在 24 小时内给出不同程度的回应。',
    level: 'key',
  },
  {
    id: 'tl6',
    time: '2025.10',
    title: '多方回应与沉默的对比',
    desc: '公开回应与保持沉默形成鲜明对照，讨论重心从事件本身转向回应方式。',
    level: 'normal',
  },
  {
    id: 'tl7',
    time: '2026.02',
    title: '事件出现反转点',
    desc: '一条此前未被注意的未删内容被翻出，时间线与主流说法出现明显出入。',
    level: 'key',
  },
  {
    id: 'tl8',
    time: '2026.06',
    title: '讨论进入冷处理阶段',
    desc: '热度曲线被压平，但原帖截图仍在被持续整理，完整版存档还在更新。',
    level: 'normal',
  },
];

export const screenshots: ScreenshotItem[] = [
  {
    id: 's1',
    title: '原帖第 1 版',
    caption: '发布后 1 小时 47 分被删，页面底部仍保留原始发布时间戳。',
    image:
      'https://readdy.ai/api/search-image?query=Vertical%20phone%20screen%20mockup%20showing%20a%20blank%20social%20post%20layout%20with%20grey%20placeholder%20blocks%2C%20deleted%20content%20overlay%20icon%2C%20dark%20warm%20amber%20backdrop%2C%20stylized%20UI%20concept%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=820&seq=llhl-shot-01&orientation=portrait',
    status: '已删',
    page: 'P.01',
  },
  {
    id: 's2',
    title: '评论区高赞楼层',
    caption: '该楼层在原作者删除动态后仍然可见，成为时间线的一条旁证。',
    image:
      'https://readdy.ai/api/search-image?query=Vertical%20app%20interface%20mockup%20with%20stacked%20comment%20placeholder%20cards%20and%20avatar%20circles%2C%20warm%20amber%20accent%20highlights%20on%20dark%20neutral%20background%2C%20stylized%20UI%20concept%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=820&seq=llhl-shot-02&orientation=portrait',
    status: '未删',
    page: 'P.02',
  },
  {
    id: 's3',
    title: '私信界面片段',
    caption: '仅截取双方称呼与时间，正文部分做了模糊处理后再归档。',
    image:
      'https://readdy.ai/api/search-image?query=Vertical%20messaging%20interface%20mockup%20with%20rounded%20chat%20bubble%20placeholders%20left%20and%20right%2C%20blurred%20content%20areas%2C%20warm%20terracotta%20gradient%20backdrop%2C%20stylized%20UI%20concept%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=820&seq=llhl-shot-03&orientation=portrait',
    status: '限时可见',
    page: 'P.03',
  },
  {
    id: 's4',
    title: '合作海报原图',
    caption: '与后来的公开版本相比，这一版多了右下角一行小字署名。',
    image:
      'https://readdy.ai/api/search-image?query=Vertical%20poster%20mockup%20with%20abstract%20geometric%20shape%20and%20blank%20caption%20area%2C%20warm%20amber%20and%20deep%20maroon%20color%20blocks%2C%20dark%20studio%20backdrop%2C%20stylized%20graphic%20design%20concept%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=820&seq=llhl-shot-04&orientation=portrait',
    status: '已删',
    page: 'P.04',
  },
  {
    id: 's5',
    title: '直播弹幕留档',
    caption: '该场直播的回放已不可见，但弹幕关键词被多个用户同步保存下来。',
    image:
      'https://readdy.ai/api/search-image?query=Vertical%20livestream%20overlay%20mockup%20with%20floating%20comment%20bars%20and%20a%20dark%20video%20placeholder%2C%20warm%20amber%20glow%20accents%2C%20stylized%20broadcast%20UI%20concept%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=820&seq=llhl-shot-05&orientation=portrait',
    status: '未删',
    page: 'P.05',
  },
  {
    id: 's6',
    title: '未删内容索引页',
    caption: '由网友自发维护的索引页，按日期与平台双重标注，仍可访问。',
    image:
      'https://readdy.ai/api/search-image?query=Vertical%20document%20index%20page%20mockup%20with%20numbered%20list%20rows%20and%20tab%20filters%2C%20warm%20amber%20highlight%20bars%20on%20dark%20paper%20texture%2C%20stylized%20archive%20UI%20concept%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=820&seq=llhl-shot-06&orientation=portrait',
    status: '限时可见',
    page: 'P.06',
  },
];

export const comments: CommentItem[] = [
  {
    id: 'c1',
    name: '吃瓜不吐皮',
    avatarColor: 'primary',
    time: '2 小时前',
    content:
      '这篇把灵灵黑料深扒细节排成时间线之后，之前看不明白的地方一下就通了，原来那三条动态发得那么近不是巧合。',
    likes: 1284,
    replies: 96,
    pinned: true,
  },
  {
    id: 'c2',
    name: '老瓜农阿澈',
    avatarColor: 'accent',
    time: '4 小时前',
    content:
      '原帖截图这块整理得挺克制，没有把未删内容和二手转述混在一起，这点比很多地方强。',
    likes: 862,
    replies: 41,
  },
  {
    id: 'c3',
    name: '只看看不说话',
    avatarColor: 'secondary',
    time: '6 小时前',
    content: '完整版那段我反复看了两遍，2025.03 那个节点真的被大部分人跳过了。',
    likes: 655,
    replies: 73,
  },
  {
    id: 'c4',
    name: '夜班摸鱼选手',
    avatarColor: 'primary',
    time: '9 小时前',
    content: '建议把每张原帖截图右上角的编号也做成可查的，找起来会更方便一点。',
    likes: 421,
    replies: 28,
  },
  {
    id: 'c5',
    name: '路过的甲',
    avatarColor: 'accent',
    time: '12 小时前',
    content: '先码住，等完整版更新到 2026.06 之后再回来看一遍。',
    likes: 318,
    replies: 12,
  },
  {
    id: 'c6',
    name: '吃瓜第一线',
    avatarColor: 'secondary',
    time: '1 天前',
    content: '冷处理那一段分析得挺冷静的，热度曲线压平不等于事情结束。',
    likes: 276,
    replies: 35,
  },
];

export const ranking: RankItem[] = [
  { id: 'r1', label: '灵灵黑料深扒细节', count: 4821, trend: 'up' },
  { id: 'r2', label: '灵灵黑料原帖截图', count: 3960, trend: 'up' },
  { id: 'r3', label: '灵灵黑料未删内容', count: 3312, trend: 'flat' },
  { id: 'r4', label: '灵灵黑料完整版', count: 2874, trend: 'up' },
  { id: 'r5', label: '事件反转点考据', count: 1420, trend: 'down' },
  { id: 'r6', label: '聊天记录时间对齐', count: 1102, trend: 'flat' },
  { id: 'r7', label: '各方回应方式对比', count: 964, trend: 'up' },
  { id: 'r8', label: '被秒删动态清单', count: 870, trend: 'down' },
];

export const navLinks = [
  { id: 'topics', label: '话题墙' },
  { id: 'digest', label: '深扒细节' },
  { id: 'posts', label: '完整版' },
  { id: 'timeline', label: '时间线' },
  { id: 'screenshots', label: '原帖截图' },
  { id: 'comments', label: '评论区' },
];

export const marqueeItems = [
  '原帖第 1 版 · 已留档',
  '未删内容索引更新至 P.06',
  '完整版时间线跨度 742 天',
  '2025.03 节点补充了新证据',
  '聊天记录时间戳已重新核对',
  '冷处理阶段仍在持续收录',
  '原帖截图共 128 条',
];